// Print-ready receipt for KTCL ETM/smart-card printer (browser print → physical printer)
export function printReceipt({ kind, data }) {
  const w = window.open("", "_blank", "width=380,height=600");
  if (!w) return;

  const isRenew = kind === "pass-renew" || kind === "card-renew";
  const isTopup = kind === "card-topup";
  const isPass  = kind === "pass" || kind === "pass-renew";

  const title =
    kind === "pass"        ? "KTCL TRAVEL PASS" :
    kind === "pass-renew"  ? "KTCL PASS RENEWAL" :
    kind === "card-renew"  ? "KTCL CARD RENEWAL" :
    kind === "card-topup"  ? "KTCL CARD TOP-UP"  : "KTCL SMART CARD";

  const idVal = isPass ? data.pass_no : data.card_no;

  let lines = [];
  let total = 0;

  if (kind === "pass") {
    lines = [["Category", data.category], ["Type", data.pass_type+" Pass"],
             ["Valid From", data.valid_from], ["Valid To", data.valid_to]];
    total = data.amount;
  } else if (kind === "pass-renew") {
    lines = [["Category", data.category], ["Renewed For", `${data.pass_type} (+${data.days||30}d)`],
             ["Old Valid To", data.valid_to], ["New Valid To", data.new_valid_to]];
    total = data.amount;
  } else if (kind === "card-topup") {
    lines = [["Type", data.card_type], ["Top-up Amount", "₹"+data.topup_amount],
             ["New Balance", "₹"+data.new_balance]];
    total = data.topup_amount;
  } else if (kind === "card-renew") {
    lines = [["Old Type", data.card_type], ["Renewed For", `+${data.days||30}d`],
             ["New Valid To", data.new_valid_to]];
    total = data.amount;
  } else {
    // Smart Card issue
    lines = [["Category", data.category], ["Type", data.card_type],
             ["Card Fare", "₹"+data.amount], ["Deposit", "₹"+data.deposit]];
    total = (data.amount||0) + (data.deposit||0);
  }

  w.document.write(`<!doctype html><html><head><title>${title}</title>
<style>
@page { size: 80mm auto; margin: 4mm; }
body { font-family: 'Courier New', monospace; font-size: 11px; color: #000; margin: 0; padding: 6mm 4mm; width: 72mm; }
.hdr { text-align:center; border-bottom:1px dashed #000; padding-bottom:6px; margin-bottom:8px; }
.brand { font-weight:900; font-size:14px; letter-spacing:1px; }
.sub { font-size:9px; margin-top:2px; }
.title { background:#000; color:#fff; padding:4px; text-align:center; font-weight:700; margin:8px 0; }
.row { display:flex; justify-content:space-between; margin:3px 0; }
.lbl { color:#444; }
.val { font-weight:700; }
.id { font-size:13px; font-weight:900; text-align:center; padding:6px; border:2px solid #000; margin:8px 0; letter-spacing:1px; }
.amt { font-size:14px; font-weight:900; text-align:center; padding:6px 0; border-top:1px dashed #000; border-bottom:1px dashed #000; margin:8px 0; }
.foot { text-align:center; font-size:9px; margin-top:10px; padding-top:6px; border-top:1px dashed #000; }
.qr { text-align:center; margin:8px 0; font-size:9px; color:#555; }
.tag { display:inline-block; padding:2px 6px; border:1px solid #000; font-size:9px; margin-top:4px; }
</style></head><body>
<div class="hdr">
  <div class="brand">KTCL · GOA</div>
  <div class="sub">Kadamba Transport Corporation Ltd.</div>
  <div class="sub">Govt. of Goa</div>
  ${(isRenew||isTopup) ? `<div class="tag">${isTopup?"TOP-UP":"RENEWAL"} RECEIPT</div>` : ""}
</div>
<div class="title">${title}</div>
<div class="id">${idVal||""}</div>
<div class="row"><span class="lbl">Holder</span><span class="val">${data.holder_name||""}</span></div>
<div class="row"><span class="lbl">Mobile</span><span class="val">${data.mobile||""}</span></div>
<div class="row"><span class="lbl">Depot</span><span class="val">${data.depot||""}</span></div>
${lines.map(([l,v]) => `<div class="row"><span class="lbl">${l}</span><span class="val">${v}</span></div>`).join("")}
<div class="amt">${isTopup ? "TOPPED-UP" : "PAID"} ₹ ${total}</div>
<div class="qr">▓▓▓ QR · TAP @ CONDUCTOR ▓▓▓</div>
<div class="foot">
  ${(isRenew||isTopup) ? "Processed" : "Issued"} ${new Date().toLocaleString("en-IN")}<br/>
  By ${data.issued_by || "Admin"}<br/>
  Helpline: 0832-2454545<br/>
  *** Thank you for travelling with KTCL ***
</div>
<script>window.onload=function(){setTimeout(function(){window.print();},250);};</script>
</body></html>`);
  w.document.close();
}
